import React, { createContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import Outlook from './components/Outlook';
import GlobalStyle from './styles/Global';
import FirstForm from './components/FirstForm';
import { colors } from './styles/utilities/settings';
import PestScores from './components/PestScores';

export const AppContext = createContext(null);

function updateProgress(evt) {
  const progress = Math.round(evt.loaded / 1000000);
  const progresBar = global.document.querySelector('#progress .bar');
  const progresNumber = global.document.querySelector('#progress p');

  if (progresBar) {
    progresBar.style.width = `${progress}%`;
  }
  if (progresNumber) {
    progresNumber.innerHTML = `${
      progress >= 80 ? 'Almost done' : `${progress}%`
    }`;
  }
}

/* eslint-disable no-undef */
function getAverage(setAverage) {
  const data = new XMLHttpRequest();
  data.onprogress = updateProgress;
  data.open(
    'GET',
    'https://pestpressureriskapi.azurewebsites.net/api/GetRiskProbabilitiesAverage',
    true
  );
  data.onreadystatechange = () => {
    if (data.readyState === 4) {
      if (data.status === 200 || data.status === 0) {
        setAverage(parseInt(JSON.parse(data.responseText), 0));
      }
    }
  };
  data.send(null);
}
/* eslint-disable no-undef */

function App() {
  const [userZip, setUserZip] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userIndustry, setUserIndustry] = useState(null);
  const [scoreWindow, setScoreWindow] = useState(false);
  const [average, setAverage] = useState(null);
  const [results, setResults] = useState(null);

  useEffect(() => {
    getAverage(setAverage);
  }, []);
  return (
    <AppContext.Provider
      value={{
        userZip,
        setUserZip,
        userEmail,
        setUserEmail,
        userIndustry,
        setUserIndustry,
        scoreWindow,
        setScoreWindow,
        average,
        results,
        setResults,
      }}
    >
      <SApp>
        <GlobalStyle />
        <Helmet>
          <meta charSet="utf-8" />
          <title>Pest Pressure</title>
        </Helmet>
        {scoreWindow ? (
          <PestScores />
        ) : (
          <>
            <Outlook />
            <div
              style={{
                display: 'block',
                height: '1px',
                background: colors.middleGray,
                margin: '30px 0',
              }}
            />
            <FirstForm />
          </>
        )}
      </SApp>
    </AppContext.Provider>
  );
}

export default App;

const SApp = styled.div`
  display: block;
`;
